"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
var decodePathname = function (pathname) {
    try {
        return decodeURIComponent(pathname);
    }
    catch (_a) {
        return pathname;
    }
};
var normalizeRoutePathname = function (pathname) {
    return decodePathname(pathname)
        .replace(/^\/metadetails(?=\/|$)/, '/detail');
};
var getPathname = function (path) { return path.split(/[?#]/)[0]; };
var getSearch = function (path) {
    var searchIndex = path.indexOf('?');
    return searchIndex !== -1 ? path.slice(searchIndex) : '';
};
var sameRoutePathname = function (location, path) {
    return normalizeRoutePathname(location.pathname) === normalizeRoutePathname(getPathname(path));
};
var sameRouteLocation = function (location, path) {
    return sameRoutePathname(location, path) && location.search === getSearch(path);
};
var navigateToRoute = function (navigate, location, path) {
    if (!sameRouteLocation(location, path)) {
        navigate(path, {
            replace: sameRoutePathname(location, path)
        });
    }
};
exports.default = navigateToRoute;
